/**
 * Theme Toggle Widget
 *
 * Renders theme selector (light/dark) from backend definition.
 */

import React, { useState } from 'react';
import type { WidgetProps } from './registry';
import './ThemeToggle.css';

export const ThemeToggleWidget: React.FC<WidgetProps> = ({
  widget,
  onChange,
}) => {
  const {
    options = [],
    value: initialValue,
    name = 'theme',
    css_style,
  } = widget;

  const [selectedTheme, setSelectedTheme] = useState(
    initialValue || options[0]?.value || 'dark'
  );

  const handleThemeChange = (value: string) => {
    setSelectedTheme(value);
    onChange?.(name, value);

    // Apply theme to document (optional - can be handled by app-level theme context)
    document.documentElement.setAttribute('data-theme', value);
  };

  return (
    <div className="rul-widget-theme-toggle" style={css_style}>
      {options.map((option: any) => (
        <button
          key={option.value}
          type="button"
          className={`rul-theme-btn ${selectedTheme === option.value ? 'active' : ''}`}
          onClick={() => handleThemeChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
